module.exports = __webpack_public_path__ + "static/media/step-3.916ec484.png";